module.exports = __webpack_public_path__ + "static/media/person5.3749d548.svg";